import { SwipeBack } from '@/components/navigation/SwipeBack';
import { InAppHistoryProvider } from '@/components/navigation/InAppHistoryProvider';
import { ApplicationRoutes, FullPageLoading } from '@/routes/AppRoutes';
import { useAuth } from '@/contexts/AuthContext';

function App() {
  const { isLoading, isBootstrapError, retryBootstrap } = useAuth();

  if (isLoading || isBootstrapError) {
    return <FullPageLoading showRetry={isBootstrapError} onRetry={retryBootstrap} />;
  }

  return (
    <InAppHistoryProvider>
      <SwipeBack />
      <ApplicationRoutes />
    </InAppHistoryProvider>
  );
}

export default App;
